var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$apollo.queries.user.loading)?_c('user-form',{attrs:{"newUser":false},on:{"submit":_vm.updateUser,"cancel":_vm.cancel},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }